/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import Grid from "@mui/material/Grid";
import React from "react";
import iconHeadlineStyle from "./iconHeadlineStyle";
import { Box } from "@mui/material";
import { IconProps } from "../../../../types/IconProps";

type IconHeadlineProps = {
  IconImage: React.ComponentType<IconProps>;
  headlineText?: string;
};

const IconHeadline = ({ IconImage, headlineText }: IconHeadlineProps) => {
  return (
    <Grid
      container
      sx={[{
        justifyContent: "center"
      }, iconHeadlineStyle.headlineContainer]}>
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <Grid container sx={{
          alignItems: "center"
        }}>
          <Grid size={3}>
            <Box sx={iconHeadlineStyle.image}>
              <IconImage />
            </Box>
          </Grid>
          <Grid size={9}>
            <Box sx={iconHeadlineStyle.contentName}>{headlineText}</Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default IconHeadline;
